import { AbstractControl } from '@angular/forms';

export function isFieldInvalid(
  form: AbstractControl | null | undefined,
  field: string
): boolean {
  if (!form) return false;
  const control = form.get(field);
  return control ? (control.invalid && (control.dirty || control.touched)) : false;
}
export const MAX_FILE_SIZE_BYTES = 5 * 1024 * 1024; // 5MB — backend ke validator se match
export const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/png', 'application/pdf'];

export function validateFile(file: File): { valid: boolean; message?: string } {
  if (file.size > MAX_FILE_SIZE_BYTES) {
    return { valid: false, message: 'File size must be under 5 MB.' };
  }
  if (!ALLOWED_FILE_TYPES.includes(file.type)) {
    return { valid: false, message: 'Only JPG, PNG, and PDF files are allowed.' };
  }
  return { valid: true };
}

export function scrollToFirstInvalidControl(dialogMode: boolean = false) {
  setTimeout(() => {
    const selectors = [
      'input.ng-invalid',
      'textarea.ng-invalid',
      'p-dropdown.ng-invalid',
      'p-calendar.ng-invalid',
      'p-autocomplete.ng-invalid',
      'p-selectbutton.ng-invalid',
      'p-chips.ng-invalid',
      'p-inputnumber.ng-invalid',
      'p-checkbox.ng-invalid',
      'p-password.ng-invalid',
      'p-editor.ng-invalid',
      'p-colorpicker.ng-invalid',
      'p-rating.ng-invalid',
      'p-listbox.ng-invalid',
      'p-multiselect.ng-invalid',
      'p-treeselect.ng-invalid',
      'p-slider.ng-invalid',
      'p-togglebutton.ng-invalid',
      'p-cascadeselect.ng-invalid',
      '.p-invalid'
    ];
    
    const invalidControls = document.querySelectorAll(selectors.join(', '));
    if (invalidControls.length === 0) return;

    let firstInvalid: HTMLElement | null = null;

    for (let i = 0; i < invalidControls.length; i++) {
        const el = invalidControls[i] as HTMLElement;
        
        let isHiddenByTabOrDialog = false;
        let parent = el.parentElement;
        while (parent && parent !== document.body) {
            const style = window.getComputedStyle(parent);
            if (style.display === 'none') {
                if (parent.classList.contains('p-toggleable-content') && parent.closest('p-accordiontab, .p-accordion-tab')) {
                   
                } else {
                    isHiddenByTabOrDialog = true;
                    break;
                }
            }
            parent = parent.parentElement;
        }

        if (!isHiddenByTabOrDialog) {
            firstInvalid = el;
            break;
        }
    }

    if (!firstInvalid) return;

    const accordionTab = firstInvalid.closest('p-accordiontab, .p-accordion-tab');
    if (accordionTab) {
        const headerLink = accordionTab.querySelector('.p-accordion-header-link, .p-accordion-header-action') as HTMLElement;
        if (headerLink && headerLink.getAttribute('aria-expanded') !== 'true') {
            headerLink.click();
        }
    }

    setTimeout(() => {
        const dialogContainer = firstInvalid?.closest('p-dialog, .p-dialog');
        if (dialogContainer) {
            const content = dialogContainer.querySelector('.p-dialog-content') as HTMLElement;
            if (content) {
                const rect = firstInvalid!.getBoundingClientRect();
                const contentRect = content.getBoundingClientRect();
                content.scrollTo({
                    top: content.scrollTop + rect.top - contentRect.top - 50,
                    behavior: 'smooth'
                });
            } else {
                firstInvalid!.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        } else {
            firstInvalid!.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        if (typeof firstInvalid!.focus === 'function') {
            firstInvalid!.focus();
        }
    }, 150);
  }, 100);
}